/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stage_Case_CreationInputs */

const en_stage_case_creation = /** @type {(inputs: Stage_Case_CreationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation`)
};

const pt_br2_stage_case_creation = /** @type {(inputs: Stage_Case_CreationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criação`)
};

/**
* | output |
* | --- |
* | "Creation" |
*
* @param {Stage_Case_CreationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_case_creation = /** @type {((inputs?: Stage_Case_CreationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Case_CreationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_case_creation(inputs)
	return pt_br2_stage_case_creation(inputs)
});